<section *ngIf="isStepByStepRun && isActiveInStepByStep" class="d-flex justify-content-end px-3">
    <button
        data-uit="step-by-step-rerun-btn"
        type="button"
        class="my-2 btn"
        ngbTooltip="{{ 'WORKFLOWS.RUNNER.TOOLTIP.RE_RERUN_BLOCKED' | translate }}"
        placement="left"
        [ngClass]="{ 'btn-secondary': !didParametersChange, 'btn-primary': didParametersChange }"
        [disabled]="isDisabled || !isFormValid || !didParametersChange"
        [class.disabled]="isDisabled || !isFormValid || !didParametersChange"
        (click)="onReRunButtonClick.emit()"
    >
        {{ 'WORKFLOWS.RUNNER.BUTTON.RERUN' | translate }}
    </button>
</section>
